var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnePlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "url(#paint0_linear)",
    strokeWidth: 1.1,
    d: "M10.966 20.612c7 0 10-11.85 10-14.666 0-2.814-4.48-5.086-10-5.086s-10 2.282-10 5.086c0 2.805 3 14.666 10 14.666z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M14.466 17.65v-.593l-2-.336V7.122l.06-3.092-.22-.207-4 1.175V5.7l1.73-.207V16.77l-2.07.287v.592h6.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.966 17.156v-.593l-2-.336V6.628l.06-3.091-.22-.208-4 1.175v.702l1.73-.208v11.279l-2.07.286v.593h6.5z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 0.966,
    x2: 0.966,
    y1: 0.86,
    y2: 20.612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF0A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3914B"
  })))));
}
SvgOnePlus.displayName = 'OnePlus';
export default SvgOnePlus;